import {Component, ElementRef, Input, OnInit, Renderer2} from '@angular/core';
import { INavData } from '../app-sidebar-nav';

@Component({
  selector: 'app-sidebar-nav-title, cui-sidebar-nav-title',
  template: '',
})
export class AppSidebarNavTitleComponent implements OnInit {
  @Input()
  item: INavData = {};

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
  ) {}

  ngOnInit() {
    const nativeElement: HTMLElement = this.el.nativeElement;
    let name = '';
    if (typeof this.item.name !== 'undefined') {
      name = this.renderer.createText(this.item.name);
    }

    if ( this.item.class ) {
      const classes = this.item.class;
      this.renderer.addClass(nativeElement, classes);
    }

    if ( this.item.wrapper ) {
      const wrapper = this.renderer.createElement(this.item.wrapper.element);
      this.addAttribs(this.item.wrapper.attributes, wrapper);
      this.renderer.appendChild(wrapper, name);
      this.renderer.appendChild(nativeElement, wrapper);
    } else {
      this.renderer.appendChild(nativeElement, name);
    }
  }

  private addAttribs(attribs: any, element: any) {
    if (attribs) {
      for (const attr in attribs) {
        if (attr === 'style' && typeof(attribs[attr]) === 'object' ) {
          this.setStyle(attribs[attr], element);
        } else if (attr === 'class') {
          this.addClass(attribs[attr], element);
        } else {
          this.setAttrib(attr, attribs[attr], element);
        }
      }
    }
  }

  private setStyle(styles: any, el: any) {
    for (const style in styles) {
      this.renderer.setStyle(el, style, styles[style] );
    }
  }

  private addClass(classes: any, el: any) {
    const classArray = (Array.isArray(classes) ? classes : classes.split(' '));
    classArray.filter((element: any) => element.length > 0).forEach((element: any) => {
      this.renderer.addClass(el, element);
    });
  }

  private setAttrib(key: any, value: any, el: any) {
    this.renderer.setAttribute(el, key, value );
  }
}
